import { IWTButton } from '../IWTButton';
import { Pages } from '../../../utils/constants';
import { useHistory } from 'react-router-dom';
import { useGlobalState } from '../../../state/state';
import { PITWarningModal } from '../../PITWarningModal/PITWarningModal';
import { useState } from 'react';
import { hasPITOrPendingChange } from '../../../utils/ruleHelper';

export interface IUpgradeBenefitIWTProps {
  variant?: 'small';
}

export const UpgradeBenefitIWT = ({ variant }: IUpgradeBenefitIWTProps) => {
  const history = useHistory();
  const [memberDetails] = useGlobalState('memberDetails');
  const [showPITWarningModal, setShowPITWarningModal] = useState(false);
  const hasPITPendingChange = hasPITOrPendingChange(memberDetails);
  const onClick = () => {
    if (hasPITPendingChange) {
      setShowPITWarningModal(true);
    } else {
      history.push(Pages.ChangeBenefitLevelPage);
    }
  };
  return (
    <>
      <IWTButton title="View my benefits" id="UpgradeBenefitIWT" variant={variant} onClick={onClick} />
      <PITWarningModal
        visible={showPITWarningModal}
        onClose={() => {
          setShowPITWarningModal(false);
        }}
      />
    </>
  );
};
